{
  "INBOX_MGMT": {
    "HEADER": "Gelen kutuları",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Yeniden bağlan",
      "FACEBOOK": "Facebook bağlantısının süresi doldu veya bağlantı iptal edildi. Sayfaya gönderilen mesajlar bu gelen kutusuna ulaşmıyor ve yanıtlar gönderilemeyebilir. Facebook sayfasını yöneten bir kişinin Yeniden bağlan düğmesine tıklaması ve Facebook'a giriş yapması gerekir.",
      "INSTAGRAM": "Instagram bağlantısının süresi doldu veya bağlantı iptal edildi. Hesaba gönderilen mesajlar bu gelen kutusuna ulaşmıyor ve yanıtlar gönderilemeyebilir. Yeniden bağlan düğmesine tıklayın ve aynı Instagram hesabıyla giriş yapın. Farklı bir hesap yeni bir gelen kutusu oluşturur.",
      "GOOGLE": "Google bağlantısının süresi doldu veya bağlantı iptal edildi. Yeni e-postalar bu gelen kutusuna ulaşmıyor ve yanıtlar gönderilemeyebilir. Yeniden bağlan düğmesine tıklayın ve Google'a {email} olarak giriş yapın.",
      "MICROSOFT": "Microsoft bağlantısının süresi doldu veya bağlantı iptal edildi. Yeni e-postalar bu gelen kutusuna ulaşmıyor ve yanıtlar gönderilemeyebilir. Yeniden bağlan düğmesine tıklayın ve Microsoft'a {email} olarak giriş yapın.",
      "ALLEGRO": "Allegro bağlantısının süresi doldu veya bağlantı iptal edildi. Alıcılardan gelen mesajlar bu gelen kutusuna ulaşmıyor ve yanıtlar gönderilemeyebilir. Yeniden bağlan düğmesine tıklayın ve Allegro'ya {seller} satıcısı olarak giriş yapın. Farklı bir satıcı hesabı yeni bir gelen kutusu oluşturur.",
      "IMAP_LOGIN": "Posta sunucusu {login} IMAP girişini reddediyor. Yeni e-postalar bu gelen kutusuna ulaşmıyor. {tab} sekmesinde IMAP kullanıcı adını ve parolasını kontrol edip kaydedin. Giriş yapmayı denemeye devam ediyoruz; giriş çalışır çalışmaz gelen kutusu eski haline döner.",
      "WHATSAPP": "WhatsApp bağlantısının süresi doldu veya bağlantı iptal edildi. Müşterilerden gelen ekler bu gelen kutusuna ulaşmıyor ve yanıtlar başarısız olabilir. Yeniden bağlan'a tıklayın, Facebook'ta oturum açın ve {phone} numarasını yeniden seçin."
    },
    "LIST": {
      "404": "Bu hesaba bağlı gelen kutusu yok.",
      "RECONNECT_REQUIRED": "Yeniden bağlanma gerekli"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Kanal Seçin",
        "BODY": "Sohbet ile entegre etmek istediğiniz sağlayıcıyı seçin."
      },
      "INBOX": {
        "TITLE": "Gelen Kutusu Oluştur",
        "BODY": "Hesabınızın kimliğini doğrulayın ve bir gelen kutusu oluşturun."
      },
      "AGENT": {
        "TITLE": "Kullanıcı Ekle",
        "BODY": "Temsilcileri oluşturulan gelen kutusuna ekleyin."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Hepiniz gitmeye hazırsınız!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Gelen Kutusu Adı",
        "PLACEHOLDER": "Gelen kutu adınızı girin (örneğin: Acme Inc)",
        "ERROR": "Lütfen geçerli bir gelen kutu adı girin"
      },
      "WEBSITE_NAME": {
        "LABEL": "Web Sitesi Adı",
        "PLACEHOLDER": "Web sitenizin adını girin"
      },
      "INTERNAL_NAME": {
        "LABEL": "Dahili Ad",
        "PLACEHOLDER": "Gelen kutusunu bu panelde görüneceği şekilde adlandırın",
        "ERROR": "Lütfen benzersiz bir dahili ad girin"
      },
      "FB": {
        "HELP": "Not: Oturum açarak, yalnızca Sayfanızın mesajlarına erişebiliriz. Özel mesajlarınıza asla erişemeyiz.",
        "CHOOSE_PAGE": "Sayfa Seçin",
        "CHOOSE_PLACEHOLDER": "Listeden bir sayfa seçin",
        "INBOX_NAME": "Gelen Kutusu Adı",
        "ADD_NAME": "Gelen kutunuza bir isim ekleyin",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Bir değer seçin",
        "CREATE_INBOX": "Gelen Kutusu Oluştur"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Instagram ile devam et",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Instagram Profilinizi Bağlayın",
        "HELP": "Instagram profilinizi bir kanal olarak eklemek için, 'Instagram ile devam et' seçeneğine tıklayarak Instagram Profilinizi doğrulamanız gerekir.",
        "ERROR_MESSAGE": "Instagram'a bağlanırken bir hata oluştu, lütfen tekrar deneyin",
        "ERROR_AUTH": "Instagram'a bağlanırken bir hata oluştu, lütfen tekrar deneyin",
        "NEW_INBOX_SUGGESTION": "Bu Instagram hesabı daha önce farklı bir gelen kutusuna bağlıydı ve şimdi buraya taşındı. Tüm yeni mesajlar burada görünecektir. Eski gelen kutusu artık bu hesap için mesaj gönderemeyecek veya alamayacaktır.",
        "DUPLICATE_INBOX_BANNER": "Bu Instagram hesabı yeni Instagram kanalı gelen kutusuna taşındı. Artık bu gelen kutusundan Instagram mesajı gönderemez/alamazsınız."
      },
      "TWITTER": {
        "HELP": "Twitter profilinizi bir kanal olarak eklemek için, 'Twitter ile Giriş Yap'ı tıklayarak Twitter Profilinizi doğrulamanız gerekir.",
        "ERROR_MESSAGE": "Twitter'a bağlanırken bir hata oluştu, lütfen daha sonra tekrar deneyin",
        "TWEETS": {
          "ENABLE": "Mentioned Tweets'ten konuşmalar oluştur"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Web Sitesi Kanalı",
        "DESC": "Web siteniz için bir kanal oluşturun ve müşterilerinizi web sitesi widget'ımız aracılığıyla desteklemeye başlayın.",
        "LOADING_MESSAGE": "Web Sitesi Destek Kanalı Oluşturma",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanal Avatarı"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Web Kanca URL'si",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Lütfen geçerli bir adres girin"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Web Sitesi Alan Adı",
          "PLACEHOLDER": "Web sitenizin adresini girin"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Hoş Geldiniz Başlığı",
          "PLACEHOLDER": "Merhaba!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Hoş Geldiniz Etiketi",
          "PLACEHOLDER": "Bizimle bağlantı kurmayı kolaylaştırıyoruz. Bize bir şey sorun veya görüşlerinizi paylaşın."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanal Karşılama Mesajı",
          "PLACEHOLDER": "Acme Inc genellikle birkaç saat içinde yanıt verir."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Kanal Karşılamasını Etkinleştir",
          "HELP_TEXT": "Yeni bir konuşma oluşturulduğunda otomatik olarak bir karşılama mesajı gönderin.",
          "ENABLED": "Etkin",
          "DISABLED": "Devre dışı"
        },
        "REPLY_TIME": {
          "TITLE": "Yanıt Zamanını Ayarlayın",
          "IN_A_FEW_MINUTES": "Birkaç dakika içinde",
          "IN_A_FEW_HOURS": "Birkaç saat içinde",
          "IN_A_DAY": "Bir gün içinde",
          "HELP_TEXT": "Bu yanıt süresi, canlı sohbet widget'ında görüntülenecek"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Rengi",
          "PLACEHOLDER": "Widget'ta kullanılacak widget rengini güncelleyin"
        },
        "SUBMIT_BUTTON": "Gelen Kutusu Oluştur",
        "API": {
          "ERROR_MESSAGE": "Web sitesi kanalı oluşturulamadı, lütfen tekrar deneyin"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Kanalı",
        "DESC": "Twilio'yu entegre edin ve müşterilerinizi SMS veya WhatsApp ile desteklemeye başlayın.",
        "ACCOUNT_SID": {
          "LABEL": "Hesap SID'si",
          "PLACEHOLDER": "Lütfen Twilio Hesap SID'nizi girin",
          "ERROR": "Bu alan gereklidir"
        },
        "API_KEY": {
          "USE_API_KEY": "API Anahtar Kimliği Kullan",
          "LABEL": "API Anahtar SID",
          "PLACEHOLDER": "Lütfen API Anahtar SID'nizi girin",
          "ERROR": "Bu alan gereklidir"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Anahtar Sırrı",
          "PLACEHOLDER": "Lütfen API Anahtar Sırrınızı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Mesajlaşma Servisi SID",
          "PLACEHOLDER": "Lütfen Twilio Mesajlaşma Servisi SID'nizi girin",
          "ERROR": "Bu alan gereklidir",
          "USE_MESSAGING_SERVICE": "Twilio Mesajlaşma Servisi Kullan"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanal Türü",
          "ERROR": "Lütfen Kanal Türünüzü seçin"
        },
        "AUTH_TOKEN": {
          "LABEL": "Yetkilendirme Jetonu",
          "PLACEHOLDER": "Lütfen Twilio Yetkilendirme Jetonunuzu girin",
          "ERROR": "Bu alan gereklidir"
        },
        "CHANNEL_NAME": {
          "LABEL": "Gelen Kutusu Adı",
          "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefon Numarası",
          "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
          "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası sağlayın."
        },
        "API_CALLBACK": {
          "TITLE": "Geri Ara URL'si",
          "SUBTITLE": "Twilio'daki mesaj geri arama URL'sini burada belirtilen URL ile yapılandırmanız gerekir."
        },
        "SUBMIT_BUTTON": "Twilio Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Twilio kimlik bilgileri doğrulanamadı, lütfen tekrar deneyin"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanalı",
        "DESC": "Müşterilerinizi SMS ile desteklemeye başlayın.",
        "PROVIDERS": {
          "LABEL": "API Sağlayıcı",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bant Genişliği",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "SMS kanalı kaydedilemedi"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Hesap Kimliği",
            "PLACEHOLDER": "Lütfen Bandwidth Hesap Kimliğinizi girin",
            "ERROR": "Bu alan gereklidir"
          },
          "API_KEY": {
            "LABEL": "API Anahtarı",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Bu alan gereklidir"
          },
          "API_SECRET": {
            "LABEL": "API Sırrı",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Bu alan gereklidir"
          },
          "APPLICATION_ID": {
            "LABEL": "Uygulama Kimliği",
            "PLACEHOLDER": "Lütfen Bandwidth Uygulama Kimliğinizi girin",
            "ERROR": "Bu alan gereklidir"
          },
          "INBOX_NAME": {
            "LABEL": "Gelen Kutusu Adı",
            "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
            "ERROR": "Bu alan gereklidir"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefon Numarası",
            "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
            "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası sağlayın."
          },
          "SUBMIT_BUTTON": "Bandwidth Kanalı Oluştur",
          "API": {
            "ERROR_MESSAGE": "Bandwidth kimlik bilgileri doğrulanamadı, lütfen tekrar deneyin"
          },
          "API_CALLBACK": {
            "TITLE": "Geri Ara URL'si",
            "SUBTITLE": "Bandwidth'taki geri arama URL'sini, burada belirtilen URL ile yapılandırmanız gerekir."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Gelen Kutusu Adı",
            "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
            "ERROR": "Bu alan gereklidir"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefon Numarası",
            "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
            "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası sağlayın."
          },
          "SUBMIT_BUTTON": "SMS Brana Kanalı Oluştur",
          "API": {
            "ERROR_MESSAGE": "SMS Brana kanalını oluşturamadık"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Gelen Kutusu Adı",
            "PLACEHOLDER": "Lütfen bir gelen kutu adı girin",
            "ERROR": "Bu alan gereklidir"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefon Numarası",
            "PLACEHOLDER": "Lütfen mesajın gönderileceği telefon numarasını girin.",
            "ERROR": "Lütfen `+` işareti ile başlayan ve boşluk içermeyen geçerli bir telefon numarası sağlayın."
          },
          "SUBMIT_BUTTON": "DIDWW Kanalı Oluştur",
          "API": {
            "ERROR_MESSAGE": "DIDWW kanalını oluşturamadık"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Sağlayıcı",
          "WHATSAPP_CLOUD": "WhatsApp Bulut"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Facebook Developer portalında aşağıda gösterilen değerlerle webhook URL'si ve doğrulama anahtarını yapılandırmanız gerekiyor.",
          "WEBHOOK_URL": "Webhook URL'si",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Onay Anahtarı"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Meta ile Hızlı Kurulum",
          "DESC": "WhatsApp Business hesabınıza giriş yapmak için Meta'ya yönlendirileceksiniz. Yönetici erişiminiz olması kurulumu sorunsuz ve kolay hale getirir.",
          "BENEFITS": {
            "EASY_SETUP": "Manuel yapılandırma gerekmez",
            "SECURE_AUTH": "Güvenli OAuth tabanlı kimlik doğrulama",
            "AUTO_CONFIG": "Otomatik webhook ve telefon numarası yapılandırması"
          },
          "SUBMIT_BUTTON": "WhatsApp Business ile Bağlan",
          "AUTH_PROCESSING": "Meta ile kimlik doğrulanıyor",
          "WAITING_FOR_BUSINESS_INFO": "Lütfen işletme kurulumunu Meta penceresinde tamamlayın...",
          "PROCESSING": "WhatsApp Business Hesabınız Kuruluyor",
          "CANCELLED": "WhatsApp kaydı iptal edildi",
          "WAITING_FOR_AUTH": "Kimlik doğrulaması bekleniyor...",
          "INVALID_BUSINESS_DATA": "Facebook'tan geçersiz işletme verisi alındı. Lütfen tekrar deneyin.",
          "SIGNUP_ERROR": "Kayıt hatası oluştu",
          "SDK_LOAD_ERROR": "Facebook SDK yüklenemedi. Lütfen tekrar deneyin.",
          "AUTH_NOT_COMPLETED": "Kimlik doğrulama tamamlanmadı. Lütfen işlemi yeniden başlatın.",
          "SUCCESS_FALLBACK": "WhatsApp Business Hesabı başarıyla yapılandırıldı",
          "RECONNECTED": "WhatsApp kanalı başarıyla yeniden bağlandı"
        },
        "API": {
          "ERROR_MESSAGE": "WhatsApp kanalını kaydedemedik"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Kanalı",
        "DESC": "API kanalı ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL'si",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL'si"
        },
        "SUBMIT_BUTTON": "API Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "API kanalını kaydedemedik"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanalı",
        "DESC": "Salesforce kanalı ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL'si",
          "SUBTITLE": "Salesforce örneğiniz için temel URL'yi yapılandırın.",
          "PLACEHOLDER": "Salesforce API URL'si"
        },
        "KEY_ID": {
          "LABEL": "Anahtar Kimliği",
          "SUBTITLE": "Salesforce kanalınız için anahtar kimliği.",
          "PLACEHOLDER": "ANAHTAR KİMLİĞİ"
        },
        "SECRET": {
          "LABEL": "Sır",
          "SUBTITLE": "Salesforce kanalınız için sır.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Salesforce Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Salesforce kanalını kaydedemedik"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL'si",
          "SUBTITLE": "Salesforce'ta webhook URL'sini burada belirtilen URL ile yapılandırmanız gerekir."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Salesforce'ta webhook'u yapılandırırken kimlik doğrulama için bu bearer token'ı kullanın."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "E-posta Gönderenini Geçersiz Kıl",
          "SUBTITLE": "Ayarlanırsa, bu e-posta adresi konuşmanın kaynak e-postası yerine tüm giden e-postalar için gönderen olarak kullanılır.",
          "PLACEHOLDER": "örn. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro Kanalı",
        "DESC": "Bir Allegro satıcı hesabı bağlayın ve mesaj merkezini İletişim Merkezi üzerinden yanıtlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Gelen Kutusu Adı",
          "SUBTITLE": "Aracıların bu gelen kutusu için gördüğü ad.",
          "PLACEHOLDER": "Bir gelen kutusu adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "SUBMIT_BUTTON": "Allegro ile oturum aç",
        "API": {
          "ERROR_MESSAGE": "Allegro'ya bağlanırken bir hata oluştu, lütfen tekrar deneyin"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro girişi",
          "SUBTITLE": "Bu gelen kutusunun mesajlarını okuyup yanıtladığı satıcı hesabı."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland Kanalı",
        "DESC": "Alıcıların Kaufland pazar yerinde size gönderdiği talep mesajlarını yanıtlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Kaufland satıcı hesabınızın API ayarları sayfasındaki 32 karakterlik Client Key.",
          "PLACEHOLDER": "32 karakterlik anahtar",
          "ERROR": "32 karakterlik Client Key değerini girin"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Client Key ile eşleşen 64 karakterlik Secret Key. Kaufland bunu bir kez gösterir ve bu sayfaya asla geri gönderilmez.",
          "PLACEHOLDER": "64 karakterlik anahtar",
          "ERROR": "64 karakterlik Secret Key değerini girin"
        },
        "SUBMIT_BUTTON": "Kaufland Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Kaufland kanalını kaydedemedik"
        },
        "DISCONNECTED": {
          "TITLE": "Bağlantı kesildi",
          "MESSAGE": "Kaufland bu API anahtarlarını reddetti. Bu gelen kutusunu yeniden bağlamak için Client Key ve Secret Key değerlerini tekrar girin."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-posta Kanalı",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "EMAIL": {
          "LABEL": "E-Posta",
          "SUBTITLE": "Müşterilerinizin size destek gönderdiği e-posta",
          "PLACEHOLDER": "E-Posta"
        },
        "SUBMIT_BUTTON": "E-posta Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "E-posta kanalını kaydedemedik"
        },
        "FINISH_MESSAGE": "E-postalarınızı aşağıdaki e-posta adresine iletmeye başlayın."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Kanalı",
        "DESC": "LINE ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Adı",
          "PLACEHOLDER": "Lütfen bir kanal adı girin",
          "ERROR": "Bu alan gereklidir"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Kanal Kimliği",
          "PLACEHOLDER": "LINE Kanal Kimliği"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Kanal Sırrı",
          "PLACEHOLDER": "LINE Kanal Sırrı"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Kanal Token",
          "PLACEHOLDER": "LINE Kanal Token"
        },
        "SUBMIT_BUTTON": "LINE Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "LINE kanalını kaydedemedik"
        },
        "API_CALLBACK": {
          "TITLE": "Geri Arama URL'si",
          "SUBTITLE": "LINE uygulamasında aşağıda belirtilen URL ile webhook URL'sini yapılandırmanız gerekiyor."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Kanalı",
        "DESC": "Telegram ile entegre edin ve müşterilerinizi desteklemeye başlayın.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Telegram BotFather'dan elde ettiğiniz bot token'ını yapılandırın.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Telegram Kanalı Oluştur",
        "API": {
          "ERROR_MESSAGE": "Telegram kanalını kaydedemedik"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefon Çağrıları",
        "DESC": "Bu gelen kutusu altında hangi telefon çağrılarının görüneceğini ayarlayın.",
        "NAME": {
          "LABEL": "Gelen Kutusu Adı",
          "SUBTITLE": "Kolayca tanınabilecek bir ad seçin."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefon Numarası",
          "SUBTITLE": "Bu gelen kutusuna ait telefon numaralarını girin, daha sonra başka numaralar da ekleyebilirsiniz.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Telefon Çağrıları Gelen Kutusu Oluştur",
        "API": {
          "ERROR_MESSAGE": "Gelen kutusunu oluşturamadık"
        }
      },
      "AUTH": {
        "TITLE": "Bir Kanal Seçin",
        "DESC": "Sohbet, canlı sohbet widget'ları, Facebook Messenger, WhatsApp, E-postalar vb. olarak kanalları destekler. Özel bir kanal oluşturmak istiyorsanız, API kanalını kullanarak bunu oluşturabilirsiniz. Başlamak için aşağıdaki kanallardan birini seçin."
      },
      "AGENTS": {
        "TITLE": "Kullanıcılar",
        "DESC": "Yeni oluşturulan gelen kutunuzu yönetmek için burada aracılar ekleyebilirsiniz. Yalnızca bu seçilen temsilciler gelen kutunuza erişebilir. Bu gelen kutusunun parçası olmayan temsilciler, oturum açtıklarında bu gelen kutusundaki mesajları göremeyecek veya yanıtlayamayacak. <br> <b> Not: </b> Bir yönetici olarak, tüm gelen kutularına erişmeniz gerekiyorsa, kendinizi oluşturduğunuz tüm gelen kutularına aracı olarak eklemelisiniz.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Gelen kutusu için aracı seçin"
      },
      "DETAILS": {
        "TITLE": "Gelen Kutusu Ayrıntıları",
        "DESC": "Sohbete bağlanmak istediğiniz Facebook Sayfasını seçmek için aşağıdaki açılır menüden seçim yapın. Daha iyi tanımlama için gelen kutunuza özel bir ad da verebilirsiniz."
      },
      "FINISH": {
        "TITLE": "Başardın!",
        "DESC": "Facebook Sayfanızı sohbet ile entegre etmeyi başarıyla tamamladınız. Bir müşteri Sayfanıza bir dahaki sefere mesaj gönderdiğinde, konuşma otomatik olarak gelen kutunuzda görünecektir. <br> Ayrıca, web sitenize kolayca ekleyebileceğiniz bir pencere öğesi komut dosyası da sağlıyoruz. Bu web sitenizde yayınlandıktan sonra, müşteriler herhangi bir harici aracın yardımı olmadan doğrudan web sitenizden size mesaj gönderebilir ve sohbet burada, sohbet ekranında görünecektir. <br> Harika, ha? Peki, emin olmaya çalışıyoruz :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "E-posta Sağlayıcınızı Seçin",
        "DESCRIPTION": "Aşağıdaki listeden bir e-posta sağlayıcı seçin. Eğer listede e-posta sağlayıcınızı görmüyorsanız, Diğer Sağlayıcı seçeneğini seçebilir ve IMAP ve SMTP Kimlik Bilgilerinizi sağlayabilirsiniz."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft E-posta",
        "DESCRIPTION": "Başlamak için Microsoft ile giriş yapın düğmesine tıklayın. E-posta giriş sayfasına yönlendirileceksiniz. İstenen izinleri kabul ettiğinizde, giriş sayfasına geri yönlendirileceksiniz.",
        "EMAIL_PLACEHOLDER": "E-posta adresini girin",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Microsoft ile bağlantı kurulurken bir hata oluştu, lütfen tekrar deneyin"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "E-posta adresini girin",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Facebook kimliğinizi doğruluyoruz...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Bir şeyler ters gitti, lütfen sayfayı yenileyin...",
      "ERROR_FB_UNAUTHORIZED": "Bu işlemi gerçekleştirmek için yetkiniz yok.",
      "ERROR_FB_UNAUTHORIZED_HELP": "Lütfen Facebook sayfanıza tam kontrolle erişiminiz olduğundan emin olun. Facebook rolleri hakkında daha fazla bilgiyi <a href=\" https://www.facebook.com/help/187316341316631\">buradan</a> okuyabilirsiniz.",
      "ERROR_CHANNEL_CREATION": "Gelen kutusu oluşturulamadı, lütfen tekrar deneyin",
      "CREATING_CHANNEL": "Gelen kutunuz oluşturuluyor...",
      "TITLE": "Gelen Kutusu Ayrıntılarını Yapılandır",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Kullanıcı Ekle",
      "ADD_AGENTS": "Gelen kutunuza aracılar ekleniyor..."
    },
    "FINISH": {
      "TITLE": "Gelen Kutunuz Hazır!",
      "MESSAGE": "Artık yeni kanalınız aracılığıyla müşterilerinizle iletişim kurabilirsiniz. Mutlu destekleme!",
      "BUTTON_TEXT": "Beni oraya götür",
      "MORE_SETTINGS": "Daha fazla ayar",
      "WEBSITE_SUCCESS": "Bir web sitesi kanalı oluşturmayı başarıyla tamamladınız. Aşağıda gösterilen kodu kopyalayın ve web sitenize yapıştırın. Bir müşteri canlı sohbeti bir dahaki sefere kullandığında, konuşma otomatik olarak gelen kutunuzda görünecektir."
    },
    "REAUTH": "Yeniden yetkilendir",
    "VIEW": "Görünüm",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Gelen kutusu ayarları başarıyla güncellendi",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Otomatik atama başarıyla güncellendi",
        "ERROR_MESSAGE": "Gelen kutusu ayarlarını güncelleyemedik. Lütfen daha sonra tekrar deneyin."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Gönderen Adı",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "Örneğin:",
        "FRIENDLY": {
          "TITLE": "Dostça",
          "FROM": "dan",
          "SUBTITLE": "Yanıtı gönderen ajanın adını gönderen adına ekleyerek dostça yapın."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesyonel",
          "SUBTITLE": "E-posta başlığında gönderen adı olarak yalnızca yapılandırılmış iş adını kullanın."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ İş adınızı yapılandırın",
          "PLACEHOLDER": "İş adınızı girin",
          "SAVE_BUTTON_TEXT": "Kaydet"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Yok"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_HMAC": {
        "LABEL": "Etkinleştir"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Etkin",
        "DISABLED": "Devre dışı"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Gelen e-postaların senkronizasyonunu etkinleştir"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Özel E-posta Alan Adını Etkinleştir (ücretli hizmet)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Facebook yorumları işlemeyi etkinleştir"
      },
      "SIGNATURE": {
        "TITLE": "HTML İmzası",
        "SUB_TEXT": "Bu imza, bu gelen kutusundan gönderilen her mesajın altbilgisine eklenecektir.",
        "HTML_CONTENT": "HTML kodu",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} ifadesi temsilcinin adıyla değiştirilir.\n{'{{'}email{'}}'} ifadesi e-postayı gönderen temsilcinin e-posta adresiyle değiştirilir.\n{'{{'}position{'}}'} ifadesi temsilcinin pozisyonuyla değiştirilir.\n{'{{'}custom_line{'}}'} ifadesi temsilcinin özel satırıyla değiştirilir.\n{'{{'}email_signature_picture{'}}'} ifadesi temsilcinin e-posta imza resminin URL'siyle değiştirilir (bir görüntü etiketi değildir) — bunu bir görüntü kaynağı olarak kullanın (bir img etiketinin src'si).",
        "PREVIEW": "Önizleme"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Ülkeye göre imzalar",
        "SUB_TEXT": "Yanıt, alıcının ülkesine göre imzalanır.",
        "HELP": "Yanıt, konuşmanın ülkesine göre imzalanır: Kaufland mağazasına, Allegro siparişinin pazar yerine veya bunlar yoksa alıcının yazdığı dile göre. Ülke bilinmiyorsa ya da burada o ülke için imza yoksa yukarıdaki HTML imzası kullanılır. Pazar yerleri web sitenize bağlantıları ve iletişim bilgilerini yasakladığından yalnızca bir selamlama ve {'{{'}name{'}}'} yazın.",
        "EMPTY": "Henüz ülke imzanız yok, bu nedenle yanıtlarda yukarıdaki HTML imzası kullanılır.",
        "COUNTRY": "Bir ülke seçin",
        "ADD": "Ülke imzası ekle",
        "REMOVE": "Kaldır"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Telefon Numarası Arama Öneki",
        "PLACEHOLDER": "Doğru çağrı yönlendirmesi için önek girin (örn. *99)",
        "HELP_TEXT": "Bu gelen kutusundan çağrı yaparken bu önek, kişilerin telefon numaralarının başına otomatik olarak eklenir."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "\"Daha sonra çözelim\" düğmesi metni",
        "PLACEHOLDER": "örn. Bu konuyu e-posta ile çözeceğiz. Şimdi başka bir şey sormak istiyorum.",
        "HELP_TEXT": "Widget'ta ziyaretçinin mevcut konudan ayrılıp başka bir şey sormasını sağlayan düğmenin metni. Boş bırakırsanız ziyaretçinin dilindeki varsayılan metin kullanılır."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Cevapsız çağrıları X dakika boyunca otomatik ertele",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Cevapsız çağrıları belirtilen dakika süresince otomatik olarak erteleyin. Devre dışı bırakmak için boş bırakın veya 0 girin."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Cevapsız çağrıyı X başarısız geri aramadan sonra çözümle",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Cevapsız bir çağrı, müşteri yanıt vermeden X kez geri arandığında otomatik olarak çözümlenir ve özel bir not eklenir. Devre dışı bırakmak için boş bırakın veya 0 girin."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Soru Önerileri",
        "SUB_TEXT": "Müşterilerin temsilcilerinizle etkileşim kurmak için kullanabileceği önceden tanımlanmış soruları yapılandırın.",
        "QUESTIONS_LABEL": "Sorular",
        "ADD_QUESTION": "Soru Ekle",
        "REMOVE": "Kaldır",
        "QUESTION_TEXT": "Kabarcıkta gösterilen metin.",
        "QUESTION_TEXT_PLACEHOLDER": "Zorunlu",
        "QUESTION_PAYLOAD": "Tıklandığında gönderilen metin.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "İsteğe bağlı",
        "NO_BOT_MESSAGE": "Ek AI önerileri oluşturmak için lütfen bir bot bağlayın.",
        "BOT_CONNECTED_MESSAGE": "Bottan gelen AI soru önerileri, bot",
        "BOT_SETTINGS_LINK": "ayarlarından etkinleştirilebilir"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatif E-postalar",
        "SUB_TEXT": "İletilen postaları alırken bu gelen kutusunun kendisine ait olarak değerlendirmesi gereken ek adresler.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Ekle",
        "REMOVE": "Kaldır",
        "EMPTY": "Yapılandırılmış alternatif e-posta yok.",
        "HELP_TEXT": "Bu adreslerden biri alıcı olarak bir e-posta geldiğinde, yanıtlar gönderen olarak aynı adresle gönderilir. Giden SMTP sunucunuzun bu adreslerden gönderime izin verdiğinden emin olun.",
        "SIGNATURE_LABEL": "İmza",
        "PRIMARY_SIGNATURE": "Birincil (varsayılan)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Ek imzalar",
        "SUB_TEXT": "Buraya ek imzalar tanımlayın, ardından bunları aşağıdaki alternatif e-postalara atayın.",
        "OPTION": "İmza {number}",
        "ADD": "İmza ekle",
        "REMOVE": "Kaldır",
        "HELP_TEXT": "Bir yanıt alternatif bir e-postadan gönderildiğinde, gelen kutusu imzası yerine ona atanan imza kullanılır. «Birincil (varsayılan)» olarak bırakılan alternatif e-postalar gelen kutusu imzasını kullanır."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Sil",
      "AVATAR_DELETE_BUTTON_TEXT": "Avatarı Sil",
      "DELETE_REQUESTED_TOOLTIP": "Bu gelen kutusu silinmek üzere işaretlendi",
      "RESTORE_BUTTON_TEXT": "Geri Yükle",
      "CONFIRM": {
        "TITLE": "Silmeyi Onayla",
        "MESSAGE": "Silmek istediğinize emin misiniz?",
        "PLACE_HOLDER": "{inboxName} yazarak onaylayın",
        "YES": "Evet, Sil ",
        "NO": "Hayır, Tut"
      },
      "API": {
        "SUCCESS_MESSAGE": "Gelen kutusu başarıyla silindi",
        "MARKED_FOR_DELETION_MESSAGE": "Gelen kutusu silinmek üzere işaretlendi",
        "RESTORE_SUCCESS_MESSAGE": "Gelen kutusu başarıyla geri yüklendi",
        "ERROR_MESSAGE": "Gelen kutusu silinemedi. Lütfen daha sonra tekrar deneyiniz.",
        "RESTORE_ERROR_MESSAGE": "Gelen kutusu geri yüklenemedi. Lütfen daha sonra tekrar deneyin.",
        "AVATAR_SUCCESS_MESSAGE": "Gelen kutusu avatarı başarıyla silindi",
        "AVATAR_ERROR_MESSAGE": "Gelen kutusu avatarı silinemiyor. Lütfen daha sonra tekrar deneyin."
      }
    },
    "TABS": {
      "SETTINGS": "Ayarlar",
      "COLLABORATORS": "Ortak Çalışanlar",
      "AUTOMATIC_PRIORITY": "Otomatik Öncelik",
      "AUTOMATIC_LABELING": "Otomatik Etiketleme",
      "CONFIGURATION": "Yapılandırma",
      "CAMPAIGN": "Kampanyalar",
      "PRE_CHAT_FORM": "Sohbet Öncesi Form",
      "BUSINESS_HOURS": "İş Saatleri",
      "WIDGET_BUILDER": "Widget Oluşturucu",
      "BOT_CONFIGURATION": "Bot Yapılandırma",
      "SLA": "SLA"
    },
    "SETTINGS": "Ayarlar",
    "FEATURES": {
      "LABEL": "Özellikleri",
      "DISPLAY_FILE_PICKER": "Widget'ta dosya seçiciyi görüntüle",
      "DISPLAY_EMOJI_PICKER": "Widget'ta emoji seçiciyi görüntüleyin",
      "ALLOW_END_CONVERSATION": "Kullanıcılara konuşmayı widget'tan sonlandırma izni ver",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Widget başlığında 'Yeni bir konuşma başlat' düğmesini göster",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Yeni konuşma başlat düğmesi gösterildiğinde giriş alanını gizle",
      "SHOW_HANDOFF_BUTTON": "Widget başlığında 'Operatöre aktar' düğmesini göster",
      "AUTO_CLOSE_OLD": "Bir çağrı çözüldüğünde aynı numaradan gelen tüm geçmiş çağrıları çözüldü olarak işaretle",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Giden çağrı yaparken cevapsız çağrıları otomatik olarak ata",
      "USE_INBOX_AVATAR_FOR_BOT": "Bot için gelen kutu adı ve avatarını kullan",
      "ALLOW_OFFLINE_REPLY": "Kişi çevrimdışıyken ve e-posta sürekliliği kullanılamıyorken temsilcilerin mesaj göndermesine izin ver"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Komut Dosyası",
      "MESSENGER_SUB_HEAD": "Bu düğmeyi gövde etiketinizin içine yerleştirin",
      "INBOX_AGENTS": "Kullanıcılar",
      "INBOX_TEAMS": "Takımlar",
      "INBOX_COOPERATORS": "Ortak Çalışanlar",
      "SELECT_PLACEHOLDER": "Seçin",
      "AGENTS_OR_TEAMS_INFO": "Temsilcileri veya takımları atayabilirsiniz - ikisini aynı anda değil.",
      "INBOX_AGENTS_SUB_TEXT": "Bu gelen kutusuna aracı ekleyin veya aracıları kaldırın",
      "AGENT_ASSIGNMENT": "Görüşme Atama",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Görüşme atama ayarlarını güncelle",
      "UPDATE": "Güncelleme",
      "ENABLE_EMAIL_COLLECT_BOX": "E-posta toplama kutusunu etkinleştir",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Yeni konuşmalarda e-posta toplama kutusunu etkinleştir veya devre dışı bırak",
      "AUTO_ASSIGNMENT": "Otomatik atamayı etkinleştir",
      "ENABLE_CSAT": "CSAT'yi etkinleştir",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Her mesajda CSAT'yi etkinleştir",
      "SENDER_NAME_SECTION": "E-postada Ajan Adını Etkinleştir",
      "ENABLE_CSAT_SUB_TEXT": "Bir konuşma çözüldükten sonra Müşteri Memnuniyeti Anketi (CSAT) etkinleştir/devre dışı bırak",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Temsilciler tarafından gönderilen her mesaj için CSAT anketi seçeneğini etkinleştir/devre dışı bırak",
      "SENDER_NAME_SECTION_TEXT": "E-postada Ajanın adını göstermeyi/Devre dışı bırakmayı etkinleştirin, devre dışı bırakıldığında iş adını gösterir",
      "ENABLE_CONTINUITY_VIA_EMAIL": "E-posta aracılığıyla konuşma sürekliliğini etkinleştir",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "E-posta adresi mevcut ise konuşmalar e-posta aracılığıyla devam eder.",
      "RESPOND_FROM_EMAIL": "E-postadan yanıtla",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Müşteriye gönderilen e-postalar — hem yanıtlar hem de konuşma dökümleri — seçilen e-posta gelen kutusunun SMTP ayarları kullanılarak seçilen adresten (gelen kutusunun kendi adresi veya takma adlarından biri) gönderilir ve müşterinin yanıtları onun IMAP adresi üzerinden geri gelir.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Konuşma dökümleri, seçilen e-posta gelen kutusunun SMTP ayarları kullanılarak seçilen adresten (gelen kutusunun kendi adresi veya takma adlarından biri) gönderilir ve yanıtlar onun IMAP adresi üzerinden geri gelir.",
      "SHOW_WELCOME_SCREEN": "Karşılama ekranını göster",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Widget açıldığında karşılama ekranını göster. Devre dışı bırakılırsa widget doğrudan konuşma görünümüne gider.",
      "AUTO_CLOSE_PENDING": "AI sohbetlerini şu süre sonra otomatik çöz (saat)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "AI sohbetlerini X saat işlem yapılmadığında otomatik olarak çöz.",
      "LOCK_TO_SINGLE_CONVERSATION": "Tek bir konuşmaya kilitle",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Bu gelen kutusu için aynı kişi için birden fazla konuşmayı etkinleştir veya devre dışı bırak",
      "INBOX_UPDATE_TITLE": "Gelen Kutusu Ayarları",
      "INBOX_UPDATE_SUB_TEXT": "Gelen kutusu ayarlarınızı güncelleyin",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Bu gelen kutusuna eklenen aracılara yeni konuşmaların otomatik olarak atanmasını etkinleştirin veya devre dışı bırakın.",
      "HMAC_VERIFICATION": "Kullanıcı Kimliği Doğrulama",
      "HMAC_DESCRIPTION": "Bu anahtar ile kullanıcılarınızın kimliğini doğrulamak için kullanılabilecek gizli bir belirteç oluşturabilirsiniz.",
      "HMAC_ROTATE": {
        "BUTTON": "Anahtarı yenile",
        "TITLE": "Gizli anahtar yenilensin mi?",
        "WARNING": "Anahtarı yenilediğiniz anda mevcut anahtar iptal edilir.",
        "WARNING_DETAIL": "Geçiş süresi yoktur ve eski anahtar geri getirilemez.",
        "IMPACT": "Sunucularınız kullanıcıları yeni anahtarla imzalamalıdır. Eski anahtarla imzalanmış olanlar doğrulamayı geçemez. Kimlik doğrulama zorunluysa bu kullanıcılar bir konuşma başlatamaz.",
        "CONFIRM": "Anahtarı yenile",
        "CANCEL": "İptal Et",
        "SUCCESS": "Gizli anahtar başarıyla yenilendi",
        "ERROR": "Gizli anahtar yenilenemedi, lütfen tekrar deneyin"
      },
      "HMAC_LINK_TO_DOCS": "Daha fazla bilgi için buraya göz atabilirsiniz.",
      "HMAC_MANDATORY_VERIFICATION": "Zorunlu Kullanıcı Kimliği Doğrulama",
      "HMAC_MANDATORY_DESCRIPTION": "Etkinleştirilmişse doğrulanamayan istekler reddedilecektir.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Her widget yüklemesinde yeni konuşma başlatmaya zorla",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Etkinleştirilirse, widget'ı yeni bir sekmede veya pencerede açmak yeni bir konuşma başlatır.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Yeni bir konuşma başlatıldığında kişiyi unut",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Devre dışı bırakılırsa, widget'tan başlatılan yeni bir konuşma önceki kişiyi korur.",
      "INBOX_IDENTIFIER": "Gelen Kutusu Tanımlayıcı",
      "INBOX_IDENTIFIER_SUB_TEXT": "API istemcilerinizi kimlik doğrulamak için burada gösterilen `inbox_identifier` belirteci ile kullanın.",
      "FORWARD_EMAIL_TITLE": "E-postaya İlet",
      "FORWARD_EMAIL_SUB_TEXT": "E-postalarınızı aşağıdaki e-posta adresine iletmeye başlayın.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-posta Senkronizasyonu",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Bu gelen kutusundaki gelen e-postaların otomatik senkronizasyonunu ve indirilmesini etkinleştir",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Özel E-posta Alan Adı",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Giden e-postalar için özel bir e-posta alan adı kullanmayı etkinleştir",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Daha fazlasını buradan okuyabilirsiniz.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook Yorumları",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Çözülen konuşmadan sonra mesajlara izin ver",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Konuşma çözüldükten sonra bile son kullanıcılara mesaj göndermelerine izin ver.",
      "WIDGET_STATUS_LABEL": "Widget Durumu",
      "WIDGET_STATUS_ENABLED": "Etkin",
      "WIDGET_STATUS_BUSINESS_HOURS": "İş saatlerinde etkin",
      "WIDGET_STATUS_DISABLED": "Devre dışı",
      "WIDGET_STATUS_HELP_TEXT": "Widget'ın web sitenizdeki ziyaretçilere ne zaman gösterileceğini kontrol edin",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Sohbet Öncesi Form Ayarlarını Güncelleme",
      "EXPLICIT_CSAT_LOCALE": "CSAT Anketi ve E-posta Dili",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "CSAT anketleri, konuşma dökümleri ve e-posta bildirimleri dahil tüm müşteri e-postaları için dili seçin",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Hesaptan devral",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp bağlantısı",
        "SUBTITLE": "Bu gelen kutusunun WhatsApp'a nasıl bağlandığı.",
        "PROVIDER": "Sağlayıcı",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Meta'nın yerleşik kaydı ile bağlandı",
        "STATUS": "Durum",
        "CONNECTED": "Bağlı",
        "RECONNECT_HINT": "Yukarıdaki uyarıda Yeniden bağlan düğmesine tıklayın.",
        "PHONE_NUMBER": "Telefon numarası",
        "BUSINESS_ACCOUNT": "WhatsApp Business Hesap Kimliği",
        "OPEN_MANAGER": "WhatsApp Manager'da aç",
        "PHONE_NUMBER_ID": "Telefon numarası kimliği",
        "TEMPLATES": "Mesaj şablonları",
        "TEMPLATES_COUNT": "{total} şablondan {approved} onaylı",
        "TEMPLATES_SYNCED": "Son eşitleme: {date}",
        "TEMPLATES_NOT_SYNCED": "Henüz eşitlenmedi",
        "MANAGE_TEMPLATES": "Şablonları yönet"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Yardım Merkezi",
      "PLACEHOLDER": "Yardım Merkezi Seçin",
      "SELECT_PLACEHOLDER": "Yardım Merkezi Seçin",
      "REMOVE": "Yardım Merkezini Kaldır",
      "SUB_TEXT": "Yardım Merkezini gelen kutusuna ekleyin"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Otomatik atama limiti",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Lütfen 0'dan büyük bir değer girin",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Bu gelen kutusundan otomatik olarak bir ajanın atanabileceği maksimum konuşma sayısını sınırlayın"
    },
    "SLA": {
      "TITLE": "SLA Politikaları",
      "SUB_TEXT": "Her konuşma öncelik düzeyi için SLA cevap ve çözüm sürelerini yapılandırın.",
      "LOADING": "SLA politikaları yükleniyor...",
      "FIELDS": {
        "ACTIVE": "Aktif",
        "TICKET_PRIORITY": "Talep Önceliği",
        "FIRST_RESPONSE_TIME": "İlk Cevap Süresi",
        "EVERY_RESPONSE_TIME": "Her Cevap Süresi",
        "RESOLUTION_TIME": "Çözüm Süresi",
        "PLACEHOLDER": "örn. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA politikaları başarıyla güncellendi.",
        "ERROR_MESSAGE": "SLA politikaları güncellenemedi. Lütfen tekrar deneyin."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Otomatik Öncelik",
      "SUB_TEXT": "Konuşma içeriğine göre otomatik öncelik atamasını yapılandırın.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Fatura Bildirimi",
        "MESSAGE": "Her öncelik değerlendirmesi bir ücrete tabidir. Fiyatlandırma bilgisi için plan ayrıntılarınızı inceleyin."
      },
      "MODE": {
        "OFF": "Kapalı",
        "ALL_MESSAGES": "Tüm gelen mesajlarda etkin",
        "FIRST_MESSAGE": "Yalnızca ilk gelen mesajda etkin"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Öncelik Düzeyi Yapılandırması",
        "SUB_TEXT": "Hangi öncelik düzeylerinin etkinleştirileceğini ve açıklamalarını yapılandırın. Bu önceliğin ne zaman atanması gerektiğini belirlemesi için AI'a net kriterler sağlayın."
      },
      "DESCRIPTION_LABEL": "Açıklama",
      "DESCRIPTION_PLACEHOLDER": "{priority} önceliği olarak işaretlenecek konuşmaları açıklayın",
      "SET_AS_DEFAULT": "Varsayılan öncelik olarak ayarla",
      "MULTIPLE_DEFAULTS_WARNING": "Yalnızca bir öncelik düzeyi varsayılan olarak ayarlanmalıdır. Lütfen diğer varsayılanların işaretini kaldırın."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Otomatik Etiketleme",
      "SUB_TEXT": "Konuşma içeriğine göre otomatik etiket atamasını yapılandırın.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Fatura Bildirimi",
        "MESSAGE": "Her etiketleme değerlendirmesi bir ücrete tabidir. Fiyatlandırma bilgisi için plan ayrıntılarınızı inceleyin."
      },
      "MODE": {
        "OFF": "Kapalı",
        "CONVERSATION_OPEN": "Konuşma açıldığında etkin",
        "CONVERSATION_CLOSE": "Konuşma kapandığında etkin",
        "ALL_MESSAGES": "Her mesajda etkin - durumdan bağımsız",
        "FIRST_MESSAGE": "İlk mesajda etkin - durumdan bağımsız"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Etiket Yapılandırması",
        "SUB_TEXT": "Otomatik atama için hangi etiketlerin kullanılabilir olacağını ve açıklamalarını yapılandırın. Bu etiketin ne zaman uygulanması gerektiğini belirlemesi için AI'a net kriterler sağlayın."
      },
      "DESCRIPTION_LABEL": "Açıklama",
      "DESCRIPTION_PLACEHOLDER": "{label} olarak etiketlenecek konuşmaları açıklayın. Boş bırakırsanız etiket açıklaması kullanılır.",
      "NO_LABELS_MESSAGE": "Etiket bulunamadı. Otomatik etiketlemeyi etkinleştirmek için önce etiket oluşturun.",
      "CREATE_LABELS_LINK": "Etiket oluştur"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Yeniden Yetkilendir",
      "SUBTITLE": "Facebook bağlantınızın süresi doldu, hizmetlere devam etmek için lütfen Facebook sayfanızı yeniden bağlayın",
      "MESSAGE_SUCCESS": "Yeniden bağlantı başarılı",
      "MESSAGE_ERROR": "Bir hata oluştu, lütfen tekrar deneyin"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Sohbet öncesi formlar, kullanıcılardan sohbet başlamadan önce bilgi toplamanıza olanak tanır.",
      "SET_FIELDS": "Sohbet Giriş Formu Alanları",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Alanlar",
        "LABEL": "Etiket",
        "PLACE_HOLDER": "Yer Tutucu",
        "KEY": "Anahtar",
        "TYPE": "Tip",
        "REQUIRED": "Zorunlu"
      },
      "ENABLE": {
        "LABEL": "Görüşme öncesi formu etkinleştir",
        "OPTIONS": {
          "ENABLED": "Evet",
          "DISABLED": "Hayır"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Görüşme öncesi mesaj",
        "PLACEHOLDER": "Bu mesaj, kullanıcılara form ile birlikte görünecek"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Ziyaretçilerin sohbeti başlamadan önce ad ve e-posta adresi sağlaması gerekmektedir"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Uygunluk Durumunuzu Ayarlayın",
      "SUBTITLE": "Canlı sohbet widget'ınızda uygunluk durumunuzu ayarlayın",
      "WEEKLY_TITLE": "Haftalık saatlerinizi ayarlayın",
      "TIMEZONE_LABEL": "Zaman Dilimini Seçin",
      "UPDATE": "İş Saatleri Ayarlarını Güncelle",
      "TOGGLE_AVAILABILITY": "Bu gelen kutusu için iş uygunluğunu etkinleştir",
      "UNAVAILABLE_MESSAGE_LABEL": "Ziyaretçiler için uygun değil mesajı",
      "TOGGLE_HELP": "İşletme erişilebilirliğini etkinleştirmek, tüm temsilciler çevrimdışı olsa bile canlı sohbet ekranında mevcut saatleri gösterecektir. Mevcut saatler dışında ziyaretçiler bir mesaj ve ön sohbet formu ile uyarılabilir.",
      "DAY": {
        "ENABLE": "Bu gün için uygunluğu etkinleştir",
        "UNAVAILABLE": "Uygun Değil",
        "HOURS": "saat",
        "VALIDATION_ERROR": "Başlangıç saati kapanış saatinden önce olmalıdır.",
        "CHOOSE": "Seçin"
      },
      "ALL_DAY": "Tüm Gün",
      "SAVE_TO_ALL": "Tüm Gelen Kutularına Kaydet",
      "SAVE_TO_ALL_TITLE": "Çalışma Saatlerini Kopyala",
      "SAVE_TO_ALL_CONFIRM": "Bu formdaki ayarlar (uygunluk anahtarı, ofis dışı mesajı, saat dilimi ve çalışma saatleri) e-posta ve telefon gelen kutuları hariç diğer tüm gelen kutularına kopyalanacaktır. Devam etmek istediğinizden emin misiniz?",
      "SAVE_TO_ALL_CANCEL": "İptal Et",
      "SAVE_TO_ALL_YES": "Evet, Tümüne Kopyala",
      "SAVE_TO_ALL_SUCCESS": "Çalışma saatleri diğer tüm gelen kutularına başarıyla kopyalandı",
      "SAVE_TO_ALL_ERROR": "Çalışma saatleri diğer gelen kutularına kopyalanamadı"
    },
    "PHONE": {
      "TITLE": "Telefon Ayarları",
      "SUBTITLE": "Bu gelen kutusu altında hangi çağrıların görüneceğini yapılandırın.",
      "UPDATE": "Ayarları kaydet",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefon ayarları güncellendi"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefon Numaraları",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "IMAP detaylarınızı ayarlayın",
      "NOTE_TEXT": "SMTP'yi etkinleştirmek için lütfen IMAP'ı yapılandırın.",
      "UPDATE": "IMAP ayarlarını güncelle",
      "TOGGLE_AVAILABILITY": "Bu gelen kutusu için IMAP yapılandırmasını etkinleştir",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP ayarları başarıyla güncellendi",
        "ERROR_MESSAGE": "IMAP ayarları güncellenemedi"
      },
      "ADDRESS": {
        "LABEL": "Adres",
        "PLACE_HOLDER": "Adres (Örnek: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Giriş",
        "PLACE_HOLDER": "Giriş"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "ENABLE_SSL": "SSL'yi Etkinleştir"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "MICROSOFT hesabınızı tekrar yetkilendirin"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "SMTP detaylarınızı ayarlayın",
      "UPDATE": "SMTP ayarlarını güncelle",
      "TOGGLE_AVAILABILITY": "Bu gelen kutusu için SMTP yapılandırmasını etkinleştir",
      "TOGGLE_HELP": "SMTP'yi etkinleştirmek, kullanıcının e-posta göndermesine yardımcı olacaktır",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP ayarları başarıyla güncellendi",
        "ERROR_MESSAGE": "SMTP ayarları güncellenemedi"
      },
      "ADDRESS": {
        "LABEL": "Adres",
        "PLACE_HOLDER": "Adres (Örnek: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Giriş",
        "PLACE_HOLDER": "Giriş"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "DOMAIN": {
        "LABEL": "Alan",
        "PLACE_HOLDER": "Alan"
      },
      "ENCRYPTION": "Şifreleme",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Doğrulama Modu",
      "AUTH_MECHANISM": "Kimlik Doğrulama"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "E-posta teslim edilebilirliği (DNS)",
      "SUB_TITLE": "{domain} alan adının SPF, DKIM, DMARC ve MX kayıtlarını her iş günü kontrol ediyoruz. Alıcı sunucuların yanıtlarınızı reddetmesine veya gereksiz posta olarak işaretlemesine neden olan bir durum varsa, yöneticilere çözümü içeren bir e-posta gönderilir.",
      "RUN": "Kontrolü çalıştır",
      "RUN_SUCCESS": "DNS kontrolü tamamlandı",
      "RUN_ERROR": "DNS kontrolü çalıştırılamadı, lütfen tekrar deneyin",
      "NOT_CHECKED": "Henüz kontrol edilmedi.",
      "CHECKED_AT": "Son kontrol: {time}.",
      "DNS_UNAVAILABLE": "Son kontrolde alan adının ad sunucularından yanıt alınamadı. Aşağıdaki sonuç bir önceki kontrole aittir.",
      "SENDER": {
        "SMTP": "Yanıtlar {host} üzerinden gönderiliyor.",
        "PLATFORM": "Yanıtlar bizim posta sunucularımız üzerinden gönderiliyor."
      },
      "STATUS": {
        "OK": "Tüm kayıtlar düzgün",
        "WARNING": "Bazı kayıtlar daha iyi olabilir",
        "ERROR": "Yanıtlar alıcılara ulaşmayabilir",
        "UNKNOWN": "Bilinmiyor"
      },
      "SEVERITY": {
        "ERROR": "Sorun",
        "WARNING": "Uyarı"
      },
      "FIX": "Bunu şu DNS kaydıyla düzeltebilirsiniz:",
      "RECORD_TYPE": "Tür",
      "RECORD_HOST": "Ad",
      "RECORD_VALUE": "Değer",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF kaydı eksik",
          "DESCRIPTION": "Alan adı, e-postalarını hangi sunucuların gönderebileceğini belirtmiyor. Bu yüzden birçok posta sunucusu yanıtlarınızı spam olarak değerlendiriyor. {sender} gönderimine izin veren bir SPF kaydı ekleyin."
        },
        "spf_multiple": {
          "TITLE": "Alan adında {count} SPF kaydı var",
          "DESCRIPTION": "Bir alan adında yalnızca bir SPF kaydı olabilir. Birden fazla olursa alıcı sunucular SPF'yi yok sayar ve e-postayı çoğu zaman reddeder. Kayıtları tek bir kayıtta birleştirin."
        },
        "spf_not_authorized": {
          "TITLE": "SPF, yanıtlarınızı gönderen sunucuya izin vermiyor",
          "DESCRIPTION": "Yanıtlarınız {sender} üzerinden gönderiliyor, ancak alan adının SPF kaydında bu sunucu yer almıyor. Mevcut kayıt: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF kaydı çok fazla DNS sorgusu gerektiriyor",
          "DESCRIPTION": "Alıcı sunucular {limit} DNS sorgusundan sonra SPF kontrolünü durdurur, ancak yanıtlarınızı gönderen {sender} ancak {lookups} sorgudan sonra bulunuyor. Bu yüzden yanıtlarınız SPF kontrolünden geçemiyor. {sender} kaydını kaydın başına taşıyın ve alan adının artık kullanmadığı include girdilerini kaldırın."
        },
        "spf_lookups_others": {
          "TITLE": "SPF kaydındaki bazı göndericiler sorgu sınırının dışında kalıyor",
          "DESCRIPTION": "SPF kaydı {lookups} DNS sorgusu gerektiriyor, alıcı sunucular {limit} sorgudan sonra duruyor. Yanıtlarınız zamanında eşleştiği için SPF kontrolünden geçiyor, ancak şu göndericilerden gelen e-postalar SPF kontrolünde başarısız oluyor: {senders}. Alan adının artık kullanmadığı include girdilerini kaldırın."
        },
        "spf_malformed": {
          "TITLE": "SPF kaydı bozuk",
          "DESCRIPTION": "Alıcı sunucular alan adının SPF kaydını okuyamıyor, bu yüzden kayıt yanıtlarınızı korumuyor. Sorun şurada: {terms}. Kaydı düzeltilmiş olanla değiştirin."
        },
        "dkim_missing": {
          "TITLE": "DKIM imzası kurulmamış",
          "DESCRIPTION": "{selectors} adresinde DKIM anahtarı bulamadık. Bu olmadan yanıtlarınız imzalanmaz ve spam klasörüne düşme olasılığı artar. E-posta sağlayıcınızdan alan adı için DKIM imzalamayı açın."
        },
        "dmarc_missing": {
          "TITLE": "DMARC kaydı eksik",
          "DESCRIPTION": "Gmail ve Microsoft gibi büyük posta sağlayıcıları DMARC kaydı bekler. Bu olmadan yanıtlarınızın spam klasörüne düşme olasılığı artar."
        },
        "dmarc_fails": {
          "TITLE": "DMARC, alıcılara yanıtlarınızı reddetmelerini söylüyor",
          "DESCRIPTION": "Alan adının DMARC politikası “{policy}” ve yanıtlarınız ne SPF ne de DKIM kontrolünden geçiyor; bu yüzden alıcılar bunları reddediyor veya spam klasörüne taşıyor. Yukarıdaki SPF ve DKIM sorunlarını düzeltin."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC, bizim posta sunucularımızdan gönderilen yanıtları engelliyor",
          "DESCRIPTION": "Bu gelen kutusu yanıtları bizim posta sunucularımız üzerinden gönderiyor, ancak alan adının DMARC politikası “{policy}” olduğundan alıcılar bunları reddediyor veya spam klasörüne taşıyor. Bu gelen kutusu için kendi posta sunucunuzun SMTP ayarlarını yapın."
        },
        "mx_missing": {
          "TITLE": "Alan adında MX kaydı yok",
          "DESCRIPTION": "MX kaydı olmadan hiç kimse alan adına e-posta gönderemez; bu yüzden müşterileriniz yanıtlarınıza cevap veremez."
        }
      }
    },
    "NOTE": "Not: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Web Sitesi Avatarı",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar başarıyla silindi",
              "ERROR_MESSAGE": "Bir hata oluştu, lütfen tekrar deneyin"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Web Sitesi Adı",
          "PLACE_HOLDER": "Web sitenizin adını girin",
          "ERROR": "Lütfen geçerli bir web sitesi adı girin"
        },
        "WELCOME_HEADING": {
          "LABEL": "Hoş Geldiniz Başlığı",
          "PLACE_HOLDER": "Merhaba!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Hoş Geldiniz Etiketi",
          "PLACE_HOLDER": "Bizimle bağlantı kurmayı kolaylaştırıyoruz. Bize bir şey sorun veya görüşlerinizi paylaşın."
        },
        "REPLY_TIME": {
          "LABEL": "Yanıt Süresi",
          "IN_A_FEW_MINUTES": "Birkaç dakika içinde",
          "IN_A_FEW_HOURS": "Birkaç saat içinde",
          "IN_A_DAY": "Bir gün içinde"
        },
        "WIDGET_COLOR_LABEL": "Widget Rengi",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Kabarcık Pozisyonu",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Okunmamış mesajların maksimum yüksekliği (px)",
          "PLACE_HOLDER": "Sınır yok",
          "HELP_TEXT": "Okunmamış mesajlar açılır penceresinin maksimum yüksekliğini piksel cinsinden sınırlayın. Varsayılan davranış için boş bırakın (sınır yok)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Kabarcık Türü",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Sohbet et",
          "LABEL": "Widget Kabarcık Başlatıcı Başlığı",
          "PLACE_HOLDER": "Sohbet et"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Widget Ayarlarını Güncelle",
          "API": {
            "SUCCESS_MESSAGE": "Widget ayarları başarıyla güncellendi",
            "ERROR_MESSAGE": "Widget ayarları güncellenemedi"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Önizleme",
          "SCRIPT": "Komut Dosyası"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Sol",
          "RIGHT": "Sağ"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standart",
          "EXPANDED_BUBBLE": "Genişletilmiş Kabarcık"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Varsayılan",
        "CHAT": "Sohbet"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Genellikle birkaç dakika içinde yanıt verir",
        "IN_A_FEW_HOURS": "Genellikle birkaç saat içinde yanıt verir",
        "IN_A_DAY": "Genellikle bir gün içinde yanıtlar"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Görüşmeyi Başlatın",
        "CHAT_INPUT_PLACEHOLDER": "Mesajınız"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Çevrimiçiyiz",
          "OFFLINE": "Şu an operatörlerimiz müsait değil"
        },
        "USER_MESSAGE": "Merhaba",
        "AGENT_MESSAGE": "Merhaba"
      },
      "BRANDING_TEXT": "JARABOT tarafından desteklenmektedir",
      "SCRIPT_SETTINGS": "\nwindow.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Diğer Sağlayıcılar"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Web sitesi",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-Posta",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Kanalı",
      "PHONE": "SIP Telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
